import { tokenString } from "@/proxy-utils"
import { BASIC_AUTH_QUERY_PARAM } from "@/types/auth"

import { isClientSide } from "./is-client-side"
import { isEmbedded } from "./is-embedded"
import { mtLocation } from "./mt-location"
import { webStorage } from "./web-storage"

export function openExploreEventSource(streamId: string): EventSource {
  let url = `/api/events?stream_id=${streamId}`

  if (isEmbedded()) {
    const authToken = webStorage.getItem("embedded.mindtrip.auth_token")
    const legacyAuthToken = webStorage.getItem("embedded.mindtrip.auth")
    if (authToken) {
      url += `&mindtrip.auth_token=${authToken}`
    } else if (legacyAuthToken) {
      url += `&mindtrip.auth=${tokenString(legacyAuthToken)}`
    }

    if (isClientSide()) {
      const searchParams = new URLSearchParams(mtLocation.search)
      const basicAuthQueryParam = searchParams.get(BASIC_AUTH_QUERY_PARAM)
      url += `&mt:basic-auth=${tokenString(basicAuthQueryParam ?? "")}`
    }
  }

  return new EventSource(url)
}
